module.exports = __webpack_public_path__ + "static/EURazvoj-29a2ce2ff42bc600009c534d69363e46.png";